export default __webpack_public_path__ + "static/media/contractorIcon.81cd7ff4.svg";